import { PAGE_INFO_FIELDS } from "@/graphql/pagination";
import gql from "graphql-tag";

export const ORGANISATION_COMMISSIONS_LIST_QUERY = gql`
  query OrganisationCommissionsListQuery(
    $organisation: Int!
    $page: Int
    $orderBy: String
    $search: String
  ) {
    organisationCommissionsPagination(
      organisation: $organisation
      page: $page
      orderBy: $orderBy
      search: $search
    ) {
      items {
        id
        dateOnInvoice
        checkoutDate
        user {
          id
          firstName
          lastName
          email
        }
        sourceBasket {
          id
          payee
          paymentStatus
          currencyName
          currencySymbol
          basketTotalCommission
        }
      }
      pageInfo {
        ...PageInfoFields
      }
    }
  }
  ${PAGE_INFO_FIELDS}
`;

export const ORGANISATION_PAYOUTS_QUERY = gql`
  query OrganisationPayoutsQuery(
    $organisation: Int!
    $startingAfter: String
    $endingBefore: String
  ) {
    organisationPayoutsPagination(
      organisation: $organisation
      startingAfter: $startingAfter
      endingBefore: $endingBefore
    ) {
      items {
        id
        initiated
        estPayout
        description
        status
        amount
        currencySymbol
      }
      hasMore
    }
  }
`;

const CONNECTED_ACCOUNT_BALANCE_FIELDS = gql`
  fragment ConnectedAccountBalanceFields on ConnectedAccountBalanceType {
    id
    currency
    currencySymbol
    pending
    available
  }
`;

export const ORGANISATION_CONNECTED_ACCOUNT_BALANCES_QUERY = gql`
  query OrganisationConnectedAccountBalancesQuery($organisation: Int!) {
    connectedAccountBalances(organisation: $organisation) {
      ...ConnectedAccountBalanceFields
    }
  }
  ${CONNECTED_ACCOUNT_BALANCE_FIELDS}
`;

export const ORGANISATION_ACCOUNT_BALANCE_QUERY = gql`
  query OrganisationAccountBalanceQuery($organisation: Int!) {
    connectedAccountBalances(organisation: $organisation) {
      ...ConnectedAccountBalanceFields
    }
    organisationNextPayoutDate(organisation: $organisation)
  }
  ${CONNECTED_ACCOUNT_BALANCE_FIELDS}
`;
